import React from 'react'
import TableCellMobile from './TableCellMobile'
import TableCellDesktop from './TableCellDesktop'

const TableCellCodeNom = ({
  item,
  label,
  device
}) => {
  const value = item.nom
  return (device.mobile)
    ? <TableCellMobile
        label={label}
        value={value}
      />
    : <TableCellDesktop
        max={150}
        value={value}
      />
}

export default TableCellCodeNom
